import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#295E60\" d=\"M.886 4.33c0-.683.554-1.237 1.237-1.237h10.973V4.33z\"></path><ellipse cx=\"16.407\" cy=\"3.711\" fill=\"#295E60\" rx=\"3.725\" ry=\"3.711\"></ellipse><path fill=\"#295E60\" d=\"M.059 4.334c0-.685.555-1.241 1.241-1.241v3.503a.62.62 0 0 1-.62.62H.401a.344.344 0 0 1-.343-.343z\"></path><rect width=\"1.242\" height=\"3.711\" x=\"2.956\" y=\"3.505\" fill=\"#295E60\" rx=\".621\"></rect><ellipse cx=\"16.303\" cy=\"3.814\" fill=\"#fff\" rx=\"2.173\" ry=\"2.165\"></ellipse>", 5)
  ])))
}
export default { render: render }